import React from 'react'
import { Spinner } from 'reactstrap'

export default function Loading() {
  return (
    <div
        style={{
           position: 'fixed',
           top: 0,
           left: 0,
           width: '100vw',
           height: '100vh',
           backgroundColor: 'rgba(255, 255, 255, 0.4)',  
           display: 'flex',
           justifyContent: 'center',
           alignItems: 'center',
           zIndex: 9999, 
        }}
    >
        <Spinner size="lg" color="primary" />
    </div>
  )
}